<template>
  <div>
    <div class="center">
      <el-carousel class="car" height="390px" autoplay>
        <el-carousel-item v-for="(item, index) in sliders" :key="index">
          <img :src="item.img" class="slider_img" />
        </el-carousel-item>
      </el-carousel>
      <div class="about_main" v-if="lang =='chs'">
        <h3 class="about_main_title">{{ mianText.title }}</h3>
        <div style="margin-bottom: 17px">{{ mianText.text1 }}</div>
        <div>{{ mianText.text2 }}</div>
      </div>
      <div class="about_main" v-else>
        <h3 class="about_main_title">{{ mianText.titleE }}</h3>
        <div style="margin-bottom: 17px">{{ mianText.text1E }}</div>
        <div>{{ mianText.text2E }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomePage",
  data() {
    return {
      sliders: [],
      lang: "",
      mianText: {
        title: "关于",
        titleE: "About",
        text1:
          "水木基金是专注于医疗、科技及新型经济产业发展、整合和并购投资机会的股权私募基金，其投资团队成员包括来自跨国投资银行、私募和创投基金及法律会计专业领域的人士。",
        text1E:
          "Waterwood is a private equity firm that invests in growth stage, industry consolidation and M&A opportunities in the healthcare, technology and new economy sectors. Its investment team comprises experienced executives and professionals from international investment banks, private equity and venture capital houses, and accounting and legal practices.",
        text2:
          "水木基金的投资者主要是家族办公室和机构投资者。为配合这些机构投资者的资产配置和回报要求，水木基金将着重寻找被关注行业内的中外领先企业，判断该些企业在经济周期和行业整合中抵御风险和把握机会的能力，配合水木基金投资团队的人脉、行业、企业管理及并购的经验和资源，在适当时候向被选定的企业投放显著的资金，让企业能够利用资本杠杆和金融效率锐变，抛离竞争对手、整合产业格局或颠覆行业的既有持分者，成为行业的龙头或开创更有利自己发展的市场空间。为配合这投资战略，水木基金会比较倾向投资于成长期的企业，一般会在被投资的企业占董事席位，主动帮助企业拓展业务，争取在中期退出并取得丰厚回报。",
        text2E:
          "Investors of Waterwood are mostly family offices and other institutional investors. To achieve the asset allocation and investment return expected by our investors, Waterwood focuses on identifying Chinese and overseas leaders in its sectors of interest and assess their ability to tackle challenges and capture opportunities through economic cycles. It seeks to deploy significant amount of capital at the right time to enable its portfolio companies to accelerate capital efficiency. In its active investment practice, Waterwood engages its portfolio companies in exploring its critical resources in business network, domain knowledge, corporate management experience, and M&A expertise. We encourage our partner entrepreneurs to fully leverage our commitments to outperform competitors, redefine industry landscape, and disrupt vested interests to become the winners and open up new business horizon. When executing this investment strategy, Waterwood generally prefers growth stage investment opportunities that can effectively deploy capital from Waterwood. We normally require board seat that allows us to take proactive steps to contribute to the development of our portfolio companies and generate significant return in midterm.",
      },
    };
  },
  methods: {},
  mounted() {
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
      this.$store.commit("setLang", lang);
    } else {
      this.lang = "chs";
      this.$store.commit("setLang", "chs");
    }
    this.sliders = [
      {
        img: require("../assets/images/ww.png"),
      },
      {
        img: require("../assets/images/ww.png"),
      },
    ];
  },
  computed: {
    listenData() {
      return this.$store.state.lang;
    },
  },
  watch: {
    listenData(newVal) {
      this.lang = newVal;
    },
  },
};
</script>

<style scoped>
.center {
  width: 1200px;
  padding: 0 15px;
  margin: auto;
}
.car {
  width: 1200px;
  height: 390px;
  margin-top: 20px;
}
.slider_img {
  width: 1200px;
  height: 390px;
}
.about_main {
  margin-top: 30px;
  min-height: 260px;
  background: #fff;
  padding: 15px 25px;
  font-size: 16px;
  box-shadow:  0 7px 14px rgb(50 50 93 / 10%), 0 3px 6px rgb(0 0 0 / 8%);
}
.about_main_title {
  padding: 15px 0;
}
</style>